const config = {
  siteTitle: "KG進化筆記 | 紅藥丸覺醒、自我提昇、財務自由、兩性心理", // Site title.
  siteTitleShort: "Kuge life", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "kugelife.com", // Alternative site title for SEO.
  siteLogo: "/logos/logo-1024.png", // Logo used for SEO and manifest.
  siteUrl: "https://kugelife2.netlify.app", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription:
    "以脫離朝九晚五，達到財富自由，達到兩性自由為目標的工程師的成長雜記", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteRssTitle: "Kuge RSS feed", // Title of the RSS feed
  siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  googleAnalyticsID: "UA-148514559-2", // GA tracking ID.
  disqusShortname: "kugelife", // Disqus shortname.
  dateFromFormat: "YYYY-MM-DD", // Date format used in the frontmatter.
  dateFormat: "DD/MM/YYYY", // Date format for display.
  postsPerPage: 0, // Amount of posts displayed per listing page.
  userName: "Kuge", // Username to display in the author segment.
  userEmail: "kugelife@gmail.com", // Email used for RSS feed's author segment
  userTwitter: "", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "North Pole, Earth", // User location to display in the author segment.
  userAvatar: "https://api.adorable.io/avatars/150/test.png", // User avatar to display in the author segment.
  userDescription: "不安分守己的工程師", // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "Facebook",
      url: "https://www.facebook.com/kgfirelife",
      iconClassName: "fa fa-facebook fa-lg",
    },
    {
      label: "Telegram",
      url: "https://t.me/kgevolution",
      iconClassName: "fa fa-telegram fa-lg",
    },
    {
      label: "Kofi",
      url: "https://ko-fi.com/kugelife",
      iconClassName: "fa fa-coffee fa-lg",
    },
    // {
    //   label: "Twitter",
    //   url: "https://twitter.com/kgfirelife",
    //   iconClassName: "fa fa-twitter fa-lg"
    // },
    {
      label: "Email",
      url: "mailto:kugelife@gmail.com",
      iconClassName: "fa fa-envelope fa-lg",
    },
  ],
  copyright: "Copyright © 2020. Kugelife", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#c62828", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0", // Used for setting manifest background color.
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === "/") {
  config.pathPrefix = "";
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, "")}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === "/")
  config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== "/")
  config.siteRss = `/${config.siteRss}`;

module.exports = config;
